import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Button
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";
import classnames from "classnames";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css'

import QuestionReviewer from './QuestionReviewer'; // Yeni bileşeni import ediyoruz

import {
  getBlogs as onGetBlogs,
  addBlog as onAddBlog,
  updateBlog as onUpdateBlog,
  deleteBlog as onDeleteBlog,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Sorular | TriMentor ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');
  const [activeTab, setActiveTab] = useState(1);

    const [isSaving, setIsSaving] = useState(false);

  // Cevap seçeneklerini yönetmek için kullanılan state
  const [options, setOptions] = useState([]);

  // Formik, ilk sekmedeki soru bilgilerinin validasyonu için kullanılacak
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      sort: (contactEdit && contactEdit.NumberOfQuestion) || "",
      subCategory: (contactEdit && contactEdit.Question_SubCategory_Sub_ID) || "",
    },
    validationSchema: Yup.object({
      sort: Yup.number().required("Lütfen soru sırasını girin."),
      subCategory: Yup.string().required("Lütfen bir kategori seçin."),
    }),
    onSubmit: values => {
      // Formik'in submit'i sadece adımlar arası geçişte validasyon için kullanılacak
      // Bu fonksiyon doğrudan bir şey yapmayacak, bunun yerine İleri butonu tetikleyecek
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.blogs,
  }));

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getCategory, setCategory] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);

  // Adımlar arası geçiş fonksiyonu
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      // İleri giderken validasyon kontrolü yap
      if (tab > activeTab) {
        validation.validateForm().then((errors) => {
          if (isEmpty(errors)) {
            setActiveTab(tab);
          } else {
            // Zorunlu alanları doldurması için Formik'in touced durumunu güncelle
            validation.setTouched({
              sort: true,
              subCategory: true,
            });
            showToast("Hata", "Lütfen ilk adımdaki tüm zorunlu alanları doldurun.", false);
          }
        });
      } else {
        // Geri giderken validasyon yapma
        setActiveTab(tab);
      }
    }
  };
  
  // Tablo kolonlarının tanımı
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        Header: "Foto",
        accessor: "Question_Title_Image",
        Cell: ({ cell: { value } }) => (
          value ? (
            <div>
              <img
                className="avatar-md"
                src={'https://megasubdomain.stechomeyazilim.info/' + value}
                alt="Soru Görseli"
              />
            </div>
          ) : <div className="avatar-md d-flex align-items-center justify-content-center"><span className="avatar-title rounded-circle bg-light text-dark">Görsel Yok</span></div>
        ),
      },
      {
        Header: "Kategori",
        accessor: "Question_SubCategory_Sub.Question_SubCategory_Sub_Text",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "Sıralama",
        accessor: "NumberOfQuestion",
        Cell: ({ cell: { value } }) => value,
      },
      {
        Header: "Cevaplar",
        accessor: "Question_Answer", // Bu accessor, API'den gelen nested array'i hedefler
        Cell: ({ cell: { value } }) => (
          <div>
            {/* HATA DÜZELTMESİ: 'value' bir dizi ise .map() çağır, değilse "Cevap Yok" yaz. */}
            {Array.isArray(value) && value.length > 0 ? (
              value.map(item => (
                <div key={item.ID}> {/* Her cevap için benzersiz veritabanı ID'sini key olarak kullan */}
                  <span className={item.Question_Answer_CheckTrue ? "text-success fw-bold" : "text-danger"}>
                    {item.Question_Answer_Text}
                  </span>
                </div>
              ))
            ) : (
              <span className="text-muted">Cevap Yok</span>
            )}
          </div>
        ),
      },
      {
        Header: "İşlemler",
        Cell: cellProps => (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleUserClick(cellProps.row.original)}
            >
              <i className="mdi mdi-pencil font-size-18" id={`edittooltip-${cellProps.row.id}`} />
              <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.id}`}>Düzenle</UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(cellProps.row.original)}
            >
              <i className="mdi mdi-delete font-size-18" id={`deletetooltip-${cellProps.row.id}`} />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.id}`}>Sil</UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  // Kategori verilerini API'den çeker
  const _getAuthData = async () => {
    try {
      const res = await axios.get(`https://trimentoradmin.stechomeyazilim.info:4436/getQuestionSubCategorySubEfso/select/`);
      setCategory(res.data);
    } catch (error) {
      console.error("Kategoriler alınamadı:", error);
    }
  };

  useEffect(() => {
    _getAuthData();
    if (isEmpty(users)) {
      dispatch(onGetBlogs());
    }
  }, [dispatch, users]);
  
  // Modal kapandığında tüm state'leri sıfırlayan fonksiyon
  const resetModalState = () => {
    setEditContact(null);
    setIsEdit(false);
    setActiveTab(1);
    setOptions([]);
    setFileName('');
    validation.resetForm();
  };

  const toggle = () => {
    if (modal) {
      resetModalState();
    }
    setModal(!modal);
  };

  // Düzenle butonuna tıklandığında çalışır
  const handleUserClick = (user) => {
    setIsEdit(true);
    setEditContact(user);
    validation.setFieldValue("sort", user.NumberOfQuestion);
    validation.setFieldValue("subCategory", user.Question_SubCategory_Sub_ID);
    setFileName(user.Question_Title_Image || '');
    const loadedOptions = user.Question_Answer ? user.Question_Answer.map(ans => ({
      id: ans.ID,
      text: ans.Question_Answer_Text,
      correct: ans.Question_Answer_CheckTrue,
    })) : [];
    setOptions(loadedOptions);
    toggle();
  };

  const onClickDelete = user => {
    setContact(user);
    setDeleteModal(true);
  };
  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteBlog(contact.ID));
    }
    setDeleteModal(false);
  };
  const handleUserClicks = () => {
    setIsEdit(false);
    toggle(); // toggle fonksiyonu zaten resetModalState'i çağırıyor
  };
  
  // Dropzone Handlers
  const getUploadParams = ({ file }) => {
      const body = new FormData();
      body.append('dataFile', file);
      return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body };
  };
  const handleChangeStatus = ({ meta, xhr, remove }, status) => {
    if (status === 'done') {
        const result = JSON.parse(xhr.response);
        setFileName(result.file.filename);
        showToast("Başarılı", `${meta.name} yüklendi.`, true);
    } else if (status === 'removed') {
        setFileName('');
    }
  };

  // SEÇENEK YÖNETİMİ FONKSİYONLARI
  const addOption = () => setOptions([...options, { id: Date.now(), text: '', correct: false }]);
  const removeOption = (id) => setOptions(options.filter(option => option.id !== id));
  const handleOptionTextChange = (id, newText) => setOptions(options.map(option => option.id === id ? { ...option, text: newText } : option));
  const setCorrectOption = (id) => setOptions(options.map(option => ({ ...option, correct: option.id === id })));

  // KAYDETME FONKSİYONU
  const handleFinalSubmit = async () => {
    if (options.length < 2) {
      showToast("Hata", "En az 2 seçenek eklemelisiniz.", false);
      return;
    }
    if (!options.some(opt => opt.correct)) {
      showToast("Hata", "Lütfen bir doğru cevap seçin.", false);
      return;
    }
    if (options.some(opt => opt.text.trim() === '')) {
      showToast("Hata", "Lütfen tüm seçenek metinlerini doldurun.", false);
      return;
    }

    const questionPayload = {
      Question_Title_Image: getFileName,
      Question_SubCategory_Sub_ID: validation.values.subCategory,
      NumberOfQuestion: validation.values.sort,
    };

    try {
      let questionId;
      if (isEdit) {
        // DÜZENLEME MODU: Mevcut soruyu güncelle
        const updatePayload = { ID: contactEdit.ID, ...questionPayload };
        dispatch(onUpdateBlog(updatePayload)); // Redux action'ı ile güncelleme
        questionId = contactEdit.ID;

        // Düzenleme modunda cevapları yönetmek için daha karmaşık bir mantık gerekir.
        // Şimdilik en basit yol: mevcut cevapları silip yenilerini eklemek.
        // Bunun için backend'de bir "deleteAnswersByQuestionId" endpoint'i olması idealdir.
        // Bu endpoint olmadığı varsayılarak, bu kısım şimdilik atlanmıştır.
        showToast("Bilgi", "Soru bilgileri güncellendi. Cevapları düzenleme henüz aktif değil.", true);
        toggle();
        return; // Cevapları güncelleme mantığı eklenene kadar burada bitir.
      } else {
        // YENİ EKLEME MODU: Yeni soru oluştur
        const questionResponse = await axios.post('https://trimentoradmin.stechomeyazilim.info:4436/addQuestionEfso/send', questionPayload);
        questionId = questionResponse.data.value[0].ID;
        if (!questionId) throw new Error("Soru ID'si alınamadı.");
      }
      
      // Oluşturulan veya güncellenen soru ID'si ile cevapları kaydet
      const answerPromises = options.map(option => {
        const answerPayload = {
          Question_ID: questionId,
          Question_Answer_Text: option.text,
          Question_Answer_CheckTrue: option.correct,
        };
        // Sadece yeni eklenen cevapları gönder (düzenleme modunda daha karmaşık bir mantık gerekir)
        if (!isEdit || (isEdit && option.id > 1000000000000)) { // Yeni eklenenlerin ID'si Date.now() ile büyük olur
            return axios.post('https://trimentoradmin.stechomeyazilim.info:4436/addQuestionAnswerEfso/send', answerPayload);
        }
        return Promise.resolve();
      });

      await Promise.all(answerPromises);
      showToast("Başarılı", "Soru ve cevaplar kaydedildi.", true);
      toggle();
      dispatch(onGetBlogs());

    } catch (error) {
      console.error("Kaydetme sırasında hata:", error);
      showToast("Hata", "İşlem sırasında bir hata oluştu.", false);
    }
  };
  
  function showToast(title, message, isSuccess) {
    toastr.options = { positionClass: "toast-top-right", timeOut: 5000, progressBar: true, closeButton: true };
    if (isSuccess) toastr.success(message, title);
    else toastr.error(message, title);
  }

   const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [extractedQuestions, setExtractedQuestions] = useState([]);

  const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setExtractedQuestions([]); // Yeni dosya seçildiğinde eski soruları temizle
    };


       const handleUploadAndExtract = async () => {
        if (!selectedFile) {
            alert("Lütfen önce bir PDF dosyası seçin.");
            return;
        }

        setIsLoading(true);
        const formData = new FormData();
        formData.append('examPdf', selectedFile);

        try {
            const response = await axios.post('https://trimentoradmin.stechomeyazilim.info:4436/extract-questions', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            setExtractedQuestions(response.data.questions);
            alert("Sorular başarıyla çekildi! Lütfen kontrol edip kaydedin.");
        } catch (error) {
            console.error("Soru çekme hatası:", error);
            alert("Soruları çekerken bir hata oluştu.");
        } finally {
            setIsLoading(false);
        }
    };
    
    // Düzenlenmiş soruları veritabanına kaydeden fonksiyon
    const handleSaveQuestionsToDB = async (questionsToSave) => {
        setIsSaving(true);
        try {
            // Backend'de bu adresi (/api/save-questions) oluşturmanız gerekecek.
            const response = await axios.post('http://localhost:5000/api/save-questions', {
                examName: selectedFile.name.replace('.pdf', ''), // Örnek sınav adı
                questions: questionsToSave
            });
            
            alert(response.data.message || "Sorular başarıyla veritabanına kaydedildi!");
            setExtractedQuestions([]); // İşlem bitince formu temizle
            setSelectedFile(null);
        } catch (error) {
            console.error("Soruları kaydetme hatası:", error);
            alert("Soruları kaydederken bir hata oluştu.");
        } finally {
            setIsSaving(false);
        }
    };



  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteUser} onCloseClick={() => setDeleteModal(false)} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Sorular" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>

              <h2>Sınav PDF'i Yükle</h2>
            <input type="file" accept=".pdf" onChange={handleFileChange} />
            <button onClick={handleUploadAndExtract} disabled={isLoading}>
                {isLoading ? 'Sorular Çekiliyor...' : 'Yükle ve Soruları Çek'}
            </button>
            
            <hr style={{ margin: '30px 0' }} />

            {/* Çekilen soruları göstermek için QuestionReviewer bileşenini kullanıyoruz */}
            <QuestionReviewer 
                questions={extractedQuestions} 
                onSave={handleSaveQuestionsToDB}
                isSaving={isSaving}
            />

            {/* Burada çekilen soruları listeleyip düzenleme formu gösterebilirsiniz. */}


                  <TableContainer
                    columns={columns} data={users} ref={tableRef} isGlobalFilter={true}
                    isAddBlog={true} handleOrderClicks={handleUserClicks} customPageSize={10}
                    className="custom-header-css"
                  />
                  <Modal size="xl" isOpen={modal} toggle={toggle} centered onClosed={resetModalState}>
                    <ModalHeader toggle={toggle} tag="h4">{isEdit ? "Soruyu Düzenle" : "Yeni Soru Ekle"}</ModalHeader>
                    <ModalBody>
                      <div className="wizard clearfix">
                        <div className="steps clearfix">
                          <ul>
                            <NavItem className={classnames({ current: activeTab === 1 })}>
                              <NavLink className={classnames({ active: activeTab === 1 })} onClick={() => setActiveTab(1)}>
                                <span className="number">1.</span> Soru Bilgileri
                              </NavLink>
                            </NavItem>
                            <NavItem className={classnames({ current: activeTab === 2 })}>
                              <NavLink className={classnames({ active: activeTab === 2 })} disabled={activeTab < 2}>
                                <span className="number">2.</span> Seçenek Bilgileri
                              </NavLink>
                            </NavItem>
                          </ul>
                        </div>
                        <div className="content clearfix">
                          <TabContent activeTab={activeTab} className="twitter-bs-wizard-tab-content">
                            <TabPane tabId={1}>
                              <Form>
                                <Row>
                                  <Col lg={6}>
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="sort">Sıralama</Label>
                                      <Input id="sort" name="sort" type="number" placeholder="Soru sırasını girin"
                                        onChange={validation.handleChange} onBlur={validation.handleBlur}
                                        value={validation.values.sort}
                                        invalid={!!(validation.touched.sort && validation.errors.sort)}
                                      />
                                      {validation.touched.sort && validation.errors.sort &&
                                        <FormFeedback type="invalid">{validation.errors.sort}</FormFeedback>}
                                    </FormGroup>
                                  </Col>
                                  <Col lg={6}>
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="subCategory">Kategori</Label>
                                      <Input id="subCategory" name="subCategory" type="select"
                                        onChange={validation.handleChange} onBlur={validation.handleBlur}
                                        value={validation.values.subCategory}
                                        invalid={!!(validation.touched.subCategory && validation.errors.subCategory)}>
                                        <option value="">Lütfen Seçim Yapınız</option>
                                        {getCategory.map(item => (
                                          <option value={item.ID} key={item.ID}>{item.Question_SubCategory_Sub_Text}</option>
                                        ))}
                                      </Input>
                                      {validation.touched.subCategory && validation.errors.subCategory &&
                                        <FormFeedback type="invalid">{validation.errors.subCategory}</FormFeedback>}
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={12}>
                                    <FormGroup>
                                      <Label>Soru Görseli (Opsiyonel)</Label>
                                      <Dropzone
                                        getUploadParams={getUploadParams} onChangeStatus={handleChangeStatus}
                                        maxFiles={1} multiple={false} canRemove={true}
                                        inputContent="Sürükleyin veya tıklayarak seçin"
                                        styles={{ dropzone: { minHeight: 120, maxHeight: 250, border: '1px dashed #ced4da' } }}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Form>
                            </TabPane>
                            <TabPane tabId={2}>
                              <Row>
                                <Col lg={12}>
                                  <h5>Cevap Seçenekleri</h5>
                                  <p className="text-muted">Lütfen seçenekleri girin ve doğru olanı işaretleyin.</p>
                                  {options.map((option, index) => (
                                    <div className="d-flex align-items-center mb-2" key={option.id}>
                                      <div className="flex-grow-1 d-flex align-items-center">
                                        <b className="me-2">{index + 1}.</b>
                                        <Input type="text" value={option.text}
                                          onChange={(e) => handleOptionTextChange(option.id, e.target.value)}
                                          placeholder={`Seçenek ${index + 1}`} className="me-2"
                                        />
                                        <Button outline color={option.correct ? "success" : "secondary"}
                                          onClick={() => setCorrectOption(option.id)}>
                                          <i className={option.correct ? "mdi mdi-check-circle" : "mdi mdi-circle-outline"}></i> Doğru
                                        </Button>
                                      </div>
                                      <Button color="danger" outline className="ms-2" onClick={() => removeOption(option.id)}>
                                        <i className="mdi mdi-delete"></i>
                                      </Button>
                                    </div>
                                  ))}
                                  <Button color="primary" outline onClick={addOption} className="mt-2">
                                    <i className="mdi mdi-plus"></i> Yeni Seçenek Ekle
                                  </Button>
                                </Col>
                              </Row>
                            </TabPane>
                          </TabContent>
                        </div>
                        <div className="actions clearfix mt-4">
                          <ul role="menu" aria-label="Pagination">
                            <li className={activeTab === 1 ? "previous disabled" : "previous"}>
                              <Link to="#" onClick={() => toggleTab(activeTab - 1)}>Geri</Link>
                            </li>
                            {activeTab < 2 &&
                              <li className="next">
                                <Link to="#" onClick={() => toggleTab(activeTab + 1)}>İleri</Link>
                              </li>
                            }
                            {activeTab === 2 &&
                              <li className="next">
                                <Link to="#" onClick={handleFinalSubmit}>
                                  {isEdit ? 'Değişiklikleri Kaydet' : 'Soruyu Kaydet'}
                                </Link>
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);